import styled from 'types/AppTheme';

/* eslint-disable no-restricted-imports */
import { BranchOfferType } from '../../constants';

import styles from './BranchEndStep.module.scss';

const StyledCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.brandColor};
  margin-right: 10px;
  margin-left: 4px;
`;

const physicalSteps = [
  {
    title: '1.  Receive a call from your local Heights Finance Branch.',
    description:
      "We will call you to discuss your loan options and answer any questions. Or if you'd like, you're welcome to call and visit your local branch.",
  },
  {
    title: '2.  Bring in documents',
    description: 'Please bring in the following items:',
    subOptions: [
      "Driver's license or government-issued ID",
      'Recent proof of income',
      'Proof of residence (current utilities or mortgage/rent bill)',
      'Vehicle Title (only required for vehicle secured loans)',
    ],
  },
  {
    title: '3.  Finalize your loan',
    options: [
      "Final approval is based on verification of applicant's personal information, income and other required information.",
      'Once verified, you can receive your funds as soon as the next day!',
    ],
  },
];

const physicalOfferSteps = [
  {
    title: '1.  Receive a call from your local Heights Finance Branch.',
    description:
      "We will call you to discuss your loan options and answer any questions. Or if you'd like, you're welcome to call and visit your local branch.",
  },
  {
    title: '2.  Bring in documents',
    description: 'Please bring in the following items:',
    subOptions: [
      "Driver's license or government-issued ID",
      'Recent proof of income',
      'Proof of residence (current utilities or mortgage/rent bill)',
      'Vehicle Title (only required for vehicle secured loans)',
    ],
  },
  {
    title: '3.  Finalize your loan',
    options: [
      'Final approval is conditional based on verification of identity, address, monthly income and expenses - additionally, for vehicle secured loans, collateral value.',
      'Once verified, you can receive your funds as soon as the next day!',
    ],
  },
];

const centralSteps = [
  {
    title: '1.  Receive a call from a Heights Finance Representative.',
    description:
      'We will call you to discuss your loan options and walk you through the process to fund your loan.',
  },
  {
    title: '2.  Please have these documents ready to expedite the process',
    description: '',
    subOptions: [
      "Driver's license or government-issued ID",
      'Recent proof of income',
      'Proof of residence (current utilities or mortgage/rent bill)',
    ],
  },
  {
    title: '3.  Finalize your loan',
    options: [
      "Final approval is based on verification of applicant's personal information, income and other required information.",
      'Once verified, you can receive your funds as soon as the next day!',
    ],
  },
];

interface IBranchInstructions {
  branchType: BranchOfferType;
  isPhysicalOffer: boolean;
}

const BranchInstructions = ({ branchType, isPhysicalOffer }: IBranchInstructions) => {
  const getBranchType = () => {
    if (isPhysicalOffer && branchType === BranchOfferType.Physical) {
      return physicalOfferSteps;
    } else if (branchType === BranchOfferType.Physical) {
      return physicalSteps;
    } else {
      return centralSteps;
    }
  };

  const steps = getBranchType();

  return (
    <div className={styles.instructionsContainer}>
      <div className={styles.title}>Here are your next steps:</div>

      {steps.map((step) => (
        <div key={step.title} className={styles.stepsWrapper}>
          <span className={styles.subTitle}>{step.title}</span>
          {step.description && <span className={styles.text}>{step.description}</span>}
          {step.subOptions &&
            step.subOptions?.map((subOption, idx) => (
              <div key={idx} className={styles.text}>
                <StyledCircle />
                <span>{subOption}</span>
              </div>
            ))}
          {step.options &&
            step.options?.map((option, i) => (
              <span key={i} className={styles.text}>
                {option}
              </span>
            ))}
        </div>
      ))}
    </div>
  );
};

export default BranchInstructions;
